import { atom } from 'recoil'

export const beePluginConfigState = atom({
  key: 'CampaignWizardBeePluginConfigState',
  default: {
    uid: undefined,
    container: 'bee-plugin-container',
    autosave: 30,
    language: undefined, // conversione come in edit messaggio email con Bee,
    specialLinks: [],
    preventClose: false,
    rowDisplayConditions: [],
    rowsConfiguration: {
      emptyRows: true,
      defaultRows: true,
      externalContentURLs: []
    },
    contentDialog: {},
    defaultForm: {
      structure: {
        title: 'Form title', // ?
        fields: undefined, // vedi parte legacy per campi email, prefisso, telefono, privacy, submit, campi anagrafici
        layout: undefined, // vedi parte legacy, è un array delle key dei fields del punto sopra
        attributes: {
          action: 'subscribe.aspx'
        }
      }
    },
    editorFonts: undefined, // come in edit messaggio email con Bee
    roleHash: undefined // se uo:LOCKCONTENTBEEEDITOR allora LockRows altrimenti NoLockRowsNoPersonalization
  }
})

export const beePluginState = atom({
  key: 'CampaignWizardBeePluginState',
  default: {
    loaded: false,
    loading: false,
    instance: undefined,
    loadedInstance: false,
    onSave: undefined
  }
})

export const editorState = atom({
  key: 'CapmaignWizardEditorState',
  default: {
    idLP: undefined,
    idTemplate: undefined,

    templateDetails: undefined,
    savedTemplate: undefined,
    savedTPLSolved: false,

    dirty: false,
    saved: false, // usato
    thirdPartyAccepted: undefined, // usato
    initialStructure: undefined, // usato
    concurrentAccessUsername: '', // usato
    loading: false // usato
  }
})

// export const EXIT = 'EXIT'
// export const SAVE = 'SAVE'
// export const SAVE_EXIT = 'SAVE AND EXIT'
